import React, { useContext } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo (2).png";
import { AuthContext } from "../../Context/AuthProvider/AuthProvider";

const Header = () => {
  const { user, userSignOut, providerSignIn } = useContext(AuthContext);
  const handleSignOut = () => {
    userSignOut().then().catch();
  };
  const handleProviderSignin = () => {
    providerSignIn()
      .then((res) => {
        const user = res.user;
      })
      .catch((e) => console.log(e));
  };

  const menuItems = (
    <>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/services">All Services</Link>
      </li>
      <li>
        <Link to="/blog">Blog</Link>
      </li>

      {user?.uid ? (
        <>
          <li>
            <Link to="/services-form">Add Services</Link>
          </li>
          <li>
            <Link to={`/myreviews/${user?.uid}`}>My Reviews</Link>
          </li>
          <li>
            <Link to="/" onClick={handleSignOut}>
              Sign Out
            </Link>
          </li>
          <li>{user?.email}</li>
        </>
      ) : (
        <li>
          <Link to="/login">Login</Link>
        </li>
      )}
    </>
  );
  return (
    <div className="navbar bg-base-100 px-10 pt-5">
      <div className="navbar-start">
        
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
           
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            {menuItems}
          </ul>
        </div>
        <img src={logo} alt="" />
        {/* <Link to='/' className=" normal-case text-xl"><img src={logo} alt="" /></Link> */}
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0">{menuItems}</ul>
      </div>
      <div className="navbar-end">
        <button
          onClick={handleProviderSignin}
          className="btn btn-outline btn-warning"
        >
          Google Login
        </button>
      </div>
    </div>
  );
};

export default Header;
